import React from 'react';

interface IFilterIconProps {
  fill?: string;
  size?: number;
  className?: string;
}

function FilterIcon({ fill = '#231F20', size = 24, className = '' }: IFilterIconProps) {
  return (
    <svg
      width={size}
      height={size}
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5 19.8077C16.6679 19.8077 15.9599 19.5157 15.376 18.9317C14.792 18.3478 14.5 17.6398 14.5 16.8077C14.5 15.9757 14.792 15.2677 15.376 14.6837C15.9599 14.0997 16.6679 13.8078 17.5 13.8078C18.332 13.8078 19.04 14.0997 19.624 14.6837C20.208 15.2677 20.5 15.9757 20.5 16.8077C20.5 17.6398 20.208 18.3478 19.624 18.9317C19.04 19.5157 18.332 19.8077 17.5 19.8077ZM17.5 18.3077C17.9166 18.3077 18.2708 18.1619 18.5625 17.8702C18.8541 17.5785 19 17.2244 19 16.8077C19 16.391 18.8541 16.0369 18.5625 15.7452C18.2708 15.4535 17.9166 15.3077 17.5 15.3077C17.0833 15.3077 16.7291 15.4535 16.4375 15.7452C16.1458 16.0369 16 16.391 16 16.8077C16 17.2244 16.1458 17.5785 16.4375 17.8702C16.7291 18.1619 17.0833 18.3077 17.5 18.3077ZM3.5 17.5577V16.0577H12.1154V17.5577H3.5ZM6.49998 10.1923C5.66794 10.1923 4.95993 9.90033 4.37595 9.31636C3.79198 8.73239 3.5 8.02439 3.5 7.19236C3.5 6.36031 3.79198 5.6523 4.37595 5.06833C4.95993 4.48437 5.66794 4.19238 6.49998 4.19238C7.33201 4.19238 8.04002 4.48437 8.624 5.06833C9.20797 5.6523 9.49995 6.36031 9.49995 7.19236C9.49995 8.02439 9.20797 8.73239 8.624 9.31636C8.04002 9.90033 7.33201 10.1923 6.49998 10.1923ZM6.49998 8.69236C6.91664 8.69236 7.27081 8.54653 7.56248 8.25486C7.85414 7.96319 7.99998 7.60903 7.99998 7.19236C7.99998 6.77569 7.85414 6.42153 7.56248 6.12986C7.27081 5.83819 6.91664 5.69236 6.49998 5.69236C6.08331 5.69236 5.72914 5.83819 5.43747 6.12986C5.14581 6.42153 4.99997 6.77569 4.99997 7.19236C4.99997 7.60903 5.14581 7.96319 5.43747 8.25486C5.72914 8.54653 6.08331 8.69236 6.49998 8.69236ZM11.8846 7.94233V6.44238H20.5V7.94233H11.8846Z"
        fill={fill}
      />
    </svg>
  );
}

export default FilterIcon;
